import React from 'react';
import ReactDOM from 'react-dom';
import Picture from '../Picture.jsx';
import VButton from '../VButton.jsx';
import { appContext } from '../../util/decorators';
import viasportLogoBlack from '../../../assets/viasport-logo-black.png';

@appContext
export default class Signup extends React.PureComponent {
  componentDidMount() {
    ReactDOM.findDOMNode(this.refs.email).focus();
  }

  render() {
    const t = this.context.app.t;

    return (
      <div className="login">
        <div className="login-head">
          <div className="login-logo">
            <Picture src={viasportLogoBlack} alt="Viasport" />
          </div>
        </div>

        <h2>{t('Signup.heading')}</h2>

        <div className="inner">
          <form>
            <fieldset>
              <label htmlFor="username" className="structural">{t('Signup.username')}</label>
              <input className="input-field" id="username" name="username" type="email" placeholder={t('Signup.username')} ref="email" required />

              <label htmlFor="password" className="structural">{t('Signup.password')}</label>
              <input className="input-field" id="password" name="password" type="password" placeholder={t('Signup.password')} required />
            </fieldset>
            <VButton type="primary">{t('Signup.register_button')}</VButton>

            <div className="border"><span className="border-text">{t('Signup.or')}</span></div>
          </form>

          <VButton type="facebook"><i className="icon-facebook"></i>{t('Signup.signup_w_fb')}</VButton>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Account/Signup.jsx